import { computed, signal } from '@angular/core';

/** Miért látszik a kártya: egér van fölötte, billentyűzettel fókuszáltak rá, vagy kattintással rögzítették. */
export type HoverCardReason = 'hover' | 'focus' | 'pin';

/**
 * Egérrel, billentyűzettel és érintéssel is nyitható kártya nyitottsága.
 * A kártya addig látszik, amíg legalább egy ok fennáll.
 */
export class HoverCardState {
  private readonly reasons = signal<ReadonlySet<HoverCardReason>>(new Set());

  readonly isOpen = computed(() => this.reasons().size > 0);
  readonly isPinned = computed(() => this.reasons().has('pin'));

  add(reason: HoverCardReason): void {
    this.reasons.update(current => new Set(current).add(reason));
  }

  remove(reason: HoverCardReason): void {
    this.reasons.update(current => new Set([...current].filter(existing => existing !== reason)));
  }

  /** Kattintás / koppintás: rögzíti a kártyát, rögzített kártyánál pedig minden okot törölve bezárja. */
  togglePin(): void {
    if (this.isPinned()) {
      this.reset();
      return;
    }
    this.add('pin');
  }

  reset(): void {
    this.reasons.set(new Set());
  }
}
